import { useLang } from "@/lib/i18n";

interface SEOProps {
  title?: string;
  description?: string;
  keywords?: string;
  image?: string;
  url?: string;
  type?: string;
}

export function SEO({
  title,
  description,
  keywords,
  image,
  url,
  type = "website",
}: SEOProps) {
  const { lang } = useLang();

  const siteName = "Awork Danışmanlık";
  const defaultDesc =
    lang === "tr"
      ? "Yabancı personel çalışma izni, oturma izni ve danışmanlık hizmetlerinde profesyonel çözüm ortağınız."
      : "Your professional partner in foreign personnel work permits, residence permits, and consulting services.";

  const defaultKeywords =
    lang === "tr"
      ? "çalışma izni, yabancı personel, oturma izni, ikamet izni, danışmanlık, turizm çalışma izni, göç idaresi, vize"
      : "work permit, foreign personnel, residence permit, consulting, tourism work permit, migration administration, visa";

  const fullTitle = title ? `${title} | ${siteName}` : siteName;
  const metaDesc = description || defaultDesc;
  const metaKeywords = keywords || defaultKeywords;

  // Clean path formatting for URLs
  const resolvedUrl = url
    ? url.startsWith("http")
      ? url
      : `https://www.aworkdanismanlik.com${url}`
    : typeof window !== "undefined"
      ? window.location.href
      : "https://www.aworkdanismanlik.com";

  const defaultImage = "https://www.aworkdanismanlik.com/awork_logo.png";
  const resolvedImage = image
    ? image.startsWith("http")
      ? image
      : `https://www.aworkdanismanlik.com${image}`
    : defaultImage;

  return (
    <>
      <title>{fullTitle}</title>
      <meta name="description" content={metaDesc} />
      <meta name="keywords" content={metaKeywords} />
      <link rel="canonical" href={resolvedUrl} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content={type} />
      <meta property="og:title" content={fullTitle} />
      <meta property="og:description" content={metaDesc} />
      <meta property="og:image" content={resolvedImage} />
      <meta property="og:url" content={resolvedUrl} />
      <meta property="og:site_name" content={siteName} />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={fullTitle} />
      <meta name="twitter:description" content={metaDesc} />
      <meta name="twitter:image" content={resolvedImage} />
    </>
  );
}
